const fromdata = [{
		title: "",
		modelvalue: "",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		multiple: false,
		color: "#424E66",
		lableheight: 0,
		types: "select",
		placeholder: "请选择主分类名称",
		width: 762,
		height: 32,
		disabled: false,
		marginLeft: 5,
		marginTop: 5,
		X: false,
		options: []
	}, {
		title: "",
		modelvalue: "",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#424E66",
		lableheight: 0,
		types: "text",
		placeholder: "请输入子分类名称",
		width: 750,
		height: 32,
		disabled: false,
		marginLeft: 5,
		marginTop: 0,
		X: false,
	},
	{
		title: "",
		modelvalue: "",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#424E66",
		lableheight: 0,
		types: "text",
		placeholder: "请输入分类备注",
		width: 750,
		height: 32,
		disabled: false,
		marginLeft: 5,
		marginTop: 0,
		X: false,
	}, {
		modelvalue: "",
		title: '',
		fontSize: '14px',
		color: '#333333',
		multiple: true,
		placeholder: '产品线',
		types: '',
		inputflag: true,
		inputtype: 'select',
		width: 762,
		marginLeft: 5,
		marginTop: 8,
		options: []
	},
];
export default fromdata;
